'use client'
import React, { useState } from 'react'

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleReadMore = () => setIsExpanded(!isExpanded)

  return (
    <div className="mt-8 mx-4">
      <h1 dir="rtl" className="text-about_headerColor text-lg font-bold text-center underline">
        אודות
      </h1>
      <div
        dir="rtl"
        className={`text-about_textColor text-lg font-medium text-center mx-auto sm:max-w-[700px] ${
          isExpanded ? '' : 'line-clamp-5 overflow-hidden'
        }`}
      >
        <p className="my-2 font-bold">
          שמי נירית, ואני בת 55 עם עשור של ניסיון בתחום הספורט.
        </p>
        <p className="my-2">
          במהלך השנים סייעתי לנשים רבות להתחזק ולהרגיש בטוחות בגופן. מתוך אהבתי לתחום הקמתי סטודיו לפילאטיס מכשירים – מקום המשלב מקצועיות, תמיכה וחוויית אימון מעצימה.
        </p>
        <p className="my-2 font-bold">מהו פילאטיס מכשירים ולמה דווקא הוא?</p>
        <p className="my-2">
          פילאטיס מכשירים משפר יציבה, מחזק את הגוף ומעניק שליטה בתנועה באמצעות עבודה מדויקת עם מכשירים ייחודיים. השיטה מתאימה לכל אישה, ללא קשר לגיל או רמת הכושר שלה.
        </p>
        <p className="my-2 font-bold">למה פתחתי סטודיו?</p>
        <p className="my-2">
          ראיתי איך נשים נאבקות למצוא זמן לעצמן. רציתי ליצור מקום שבו הן יוכלו להתחבר לגופן, לנוע בחופשיות ולבנות חוסן פיזי ונפשי.
        </p>
        <p className="my-2">
          הסטודיו שלי הוא יותר ממקום אימון – הוא מרחב שמעצים נשים בכל שלב בחיים.
        </p>
        <p className="my-2 font-bold">מזמינה אותך לשיעור נסיון ב 50% הנחה   </p>
      </div>

      <button
        onClick={toggleReadMore}
        className="text-about_callToActionTextColors text-sm font-bold text-center mx-auto mt-2 block underline"
      >
        {isExpanded ? 'קרא פחות' : 'קרא עוד'}
      </button>
    </div>
  )
}

export default About
